import { message } from "antd";
import BaseApi from "./BaseApi";
import BaseAdminApi from "./BaseAdminApi";


class AuthServieApi extends BaseApi {
  // signUp User
  static async signUp(email, password, storeDescription) {
    try {
      // Sign up the user
      const { data: signUpData, error: signUpError } =
        await this.supabase.auth.signUp({
          email,
          password,
          // options: {
          //   emailRedirectTo: `http://localhost:3000/userInfo/${signUpData?.user?.id}`,
          // },
          //options: { 
            // emailRedirectTo: "https://optix360-app.mayaartech.com/userInfo", // comment for Avoid Email Confirmation and email confirmation option disable from Supabase
          //   emailRedirectTo: "http://localhost:3000/userInfo",
          // },
        });
      if (signUpError) throw signUpError;

      // Check if the user needs to confirm their email
      if (signUpData.user && !signUpData.user.email_confirmed_at) {
        message.success(
          "Please check your email to verify your account before logging in."
        );
      } else {
        message.success("User signed up and email is already confirmed.");
      }

      // Get the user ID (Supabase may return it in the session data after sign-up)
      const userId = signUpData.user?.id;
      if (!userId) throw new Error("User ID not Found after sign-up.");

      //Create a store associated with the new user
      const { data: storeData, error: storeError } = await this.supabase
        .from("e_store")
        .insert({
          name: email,
          description: storeDescription,
          u_id: userId,
          // type: "Retail & Wholesale",
        })
        .select()
        .single();
      if (storeError) throw storeError;

      //Create a member of member Table
      const { data: memberData, error: memberError } = await this.supabase
        .from("members")
        .insert({
          name: email,
          roles: "Admin",
          u_id: userId,
          s_id: storeData.s_id,
        })
        .select()
        .single();

      if (memberError) throw memberError;

      return {
        data: { user: signUpData.user, store: storeData, member: memberData },
        error: null,
      };
    } catch (error) {
      console.error(
        "Sign up, store creation, or member creation error:",
        error.message
      );
      return { data: null, error };
    }
  }

  //Resend Email Confirmation
  static async resendConfirmationEmail(email) {
    try {
      const { error } = await this.supabase.auth.resend({
        type: "signup",
        email,
      });

      if (error) throw error;


      return {
        success: true,
        message: "Confirmation email resent successfully.",
      };
    } catch (error) {
      console.error("Error resending confirmation email:", error.message);
      return { success: false, message: error.message };
    }
  }

  // update UserInfo
  static async updateMember(memberData) {
      const { id, ...updateFields } = memberData; // remove id
    try {
      const { data, error } = await this.supabase
        .from("members")
        .update(updateFields)
        .eq("id", id)
        .select();

      if (error) {
        throw new Error(error.message);
      }

      return { data, error: null };
    } catch (e) {
      console.error("Error updating member:", e);
      return { data: null, error: e };
    }
  }
  //Update StoreInfo
  static async updateStore(storeData) {
    try {
      const { data, error } = await this.supabase
        .from("e_store")
        .update(storeData)
        .eq("u_id", storeData.u_id)
        .select();
      if (error) {
        throw new Error(error.message);
      }
      return { data, error: null };
    } catch (e) {
      console.error("Error updating Store:", e);
      return { data: null, error: e };
    }
  }

  // signIn user
  static async signIn(email, password) {
    try {
      const { data, error } = await this.supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        return { data: null, error };
      }

      return { data, error: null };
    } catch (error) {
      console.error("Sign in error:", error.message);
      return { data: null, error };
    }
  }

  // signOut user
  static async signOut() {
    try {
      const { error } = await this.supabase.auth.signOut();
      if (error) throw error;
      return null;
    } catch (error) {
      console.error("Sign out error:", error.message);
      return error;
    }
  }

  // Update the user's password in App
  static async updatePassword(newPassword) {
    try {
      const { data, error } = await this.supabase.auth.updateUser({
        password: newPassword,
      });

      if (error) throw new Error(error.message);

      return { data, error: null };
    } catch (error) {
      console.error("Error updating password:", error.message);
      return { data: null, error };
    }
  }
}

class ResetPasswordApi extends BaseAdminApi {
  static async sendResetLink(email) {
    try {
      //Check if email exists (server-side only)
      const { data: users, error: listError } = await this.supabase.auth.admin.listUsers();
  
      if (listError) throw listError;
      const userExists = users?.users?.some(
        (user) => user.email?.toLowerCase() === email.toLowerCase()
      );
  
      if (!userExists) {
        throw new Error("No account registered with this email.");
      }
  
      //Send reset password link
      const { data, error } = await this.supabase.auth.resetPasswordForEmail(email, {
        redirectTo: "http://localhost:3000/SetNewPassword",
        // redirectTo: "https://optix360-app.mayaartech.com/SetNewPassword",
      });
  
      if (error) throw error;
  
      return { data, error: null };
    } catch (error) {
      console.error("Error sending reset link:", error.message);
      return { data: null, error };
    }
  }
}
export default AuthServieApi;
export { ResetPasswordApi };